import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {Map, List} from 'immutable';

import Form from '../../Form';

class SportPriceLaddersForm extends Form {
    static fieldsValidation = {
        d: [['required'], 'decimal'],
        f: ['required', 'fractional'],
        enabled: ['required']
    };

    renderForm() {
        let { data } = this.state;

        return (
            <section className="row sport-ladder-form">
                <div className="col-12">
                    <div className="col-4">
                        {
                            this.getField(
                                <input
                                    type="text"
                                    disabled
                                    { ...this.getFieldParameters('d') }
                                />
                            )
                        }
                    </div>
                    <div className="col-4">
                        {
                            this.getField(
                                <input
                                    type="text"
                                    disabled
                                    { ...this.getFieldParameters('f') }
                                />
                            )
                        }
                    </div>
                    <div className="col-4 switcher">
                        {
                            this.getCheckbox(
                                'enabled',
                            )
                        }
                    </div>
                </div>
            </section>
        )
    }
}

export default SportPriceLaddersForm;
